(() => {
  const SELECTOR = '[data-mr-more-recipes]';

  function shuffle(items) {
    const shuffled = [...items];

    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(
        Math.random() * (index + 1)
      );

      [shuffled[index], shuffled[randomIndex]] = [
        shuffled[randomIndex],
        shuffled[index]
      ];
    }

    return shuffled;
  }

  function initialize(section) {
    if (!section || section.dataset.mrInitialized === 'true') {
      return;
    }

    const template = section.querySelector(
      '[data-mr-more-recipes-template]'
    );

    const track = section.querySelector(
      '[data-mr-more-recipes-track]'
    );

    const emptyMessage = section.querySelector(
      '[data-mr-more-recipes-empty]'
    );

    if (!template || !track) {
      return;
    }

    const requestedCount = Number.parseInt(
      section.dataset.recipeCount || '3',
      10
    );

    const sourceCards = Array.from(
      template.content.querySelectorAll(
        '[data-mr-more-recipes-card]'
      )
    );

    track.replaceChildren();

    if (sourceCards.length === 0) {
      if (emptyMessage) {
        emptyMessage.hidden = false;
      }

      section.dataset.mrInitialized = 'true';
      return;
    }

    const selectedCards = shuffle(sourceCards).slice(
      0,
      Math.min(requestedCount, sourceCards.length)
    );

    const fragment = document.createDocumentFragment();

    selectedCards.forEach((card) => {
      fragment.appendChild(card.cloneNode(true));
    });

    track.appendChild(fragment);

    if (emptyMessage) {
      emptyMessage.hidden = true;
    }

    section.dataset.mrInitialized = 'true';
  }

  function initializeAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section = event.target.matches?.(SELECTOR)
        ? event.target
        : event.target.querySelector?.(SELECTOR);

      if (section) {
        delete section.dataset.mrInitialized;
        initialize(section);
      }
    }
  );
})();
